var React = require('react');

function Gatsby (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M600 0C268.6 0 0 268.6 0 600s268.6 600 600 600 600-268.6 600-600S931.4 0 600 0zM266.6 933.3C176.1 842.8 131 724.6 129.6 606L594 1070.4c-118.6-1.4-236.8-46.5-327.4-137.1zm437.7 126.1L140.6 495.7c47.5-210.1 235-367.1 459.4-367.1 156.9 0 295.5 77 381.2 194.9L915.6 379C845.8 279.5 730.5 214.3 600 214.3c-167.7 0-310.3 107.7-363.3 257.5l491.6 491.6c123.4-43.7 218-148.2 247.6-277.6H771.4V600h300c0 224.5-157 411.9-367.1 459.4z","fill":"#639"}));
}

Gatsby.defaultProps = {"viewBox":"0 0 1200 1200","focusable":"false"};

module.exports = Gatsby;

Gatsby.default = Gatsby;
